
const fg_no_states = [ 'AK', 'HI', 'MS', 'RI', 'SD', 'UT' ];

const fg_wh_states = {
    "ETC": [ 'AL','AK','GA','IL','ID','IA','KS','KY','LA','MI','MN','MS','MO','NE','ND','OH','OK','SD','TN','TX','WV','WI' ],
    "COB": [ 'CT','DE','DC','FL','ME','MD','MA','NH','NJ','NY','NC','PA','RI','SC','VT','VA' ],
    "VCX": [ 'AZ','CA','CO','HI','ID','MT','NV','NM','OR','UT','WA','WY' ]
}

const FREQUENCY_MS = 1000 * 60 * 60 * 24;

// If the user selected a state, set the current WH
var fg_wh = '';

function setCurrentWarehouse() {
    const currentState = window.localStorage.getItem('fgw_state');
    if (currentState) {
        // in entries: 0 is key, 1 is value
        const entryForState = Object.entries(fg_wh_states).find((anEntry) => anEntry[1].includes(currentState));
        if (entryForState) {
            fg_wh = entryForState[0];
        } else {
            fg_wh = '';
        }
    }
}

function enableAvailabilityElements() {
    const availabilityElements = document.querySelectorAll('[data-fg-availability-element]');
    availabilityElements.forEach((element) => {
        element.removeAttribute('disabled');
        element.classList.remove('disabled');
        const oosTextEl = element.querySelector('[data-fg-oos-text]');
        if (oosTextEl) {
            const oosText = oosTextEl.getAttribute("data-fg-atc-text");
            if (oosText) {
                oosTextEl.innerText = oosTextEl.getAttribute("data-fg-atc-text");
                oosTextEl.removeAttribute("data-fg-atc-text");
            }
        }

    });

    // hide all "item cannot ship to your state" elements
    document.querySelectorAll('[data-unavailable-state]').forEach((el) => {
        el.setAttribute('hidden', '');
        const thingToDisable = el.closest('[data-unavailable-disable]');
        const thingsToCover = el.parentElement.querySelectorAll('[data-unavailable-cover]');
        if (thingToDisable) thingToDisable.classList.remove('unavail_disable');
        if (thingsToCover) thingsToCover.forEach((thing) => thing.classList.remove('unavail_cover'));
    });

}

function disableElements(elements, newText) {
    for(const anElement of elements) {
        const availabilityContainer = anElement.closest('[data-unavailable-disable]');
        const availabilityElements = availabilityContainer.querySelectorAll('[data-fg-availability-element]');
        availabilityElements.forEach((element) => {
            element.setAttribute('disabled', '');
            element.classList.add('disabled');
            if (newText) {
                const oosTextEl = element.querySelector('[data-fg-oos-text]');
                if (oosTextEl) {
                    oosTextEl.setAttribute("data-fg-atc-text", oosTextEl.innerText);
                    oosTextEl.innerText = newText;
                }
            }
        });
    }
}

function showUnavailable(elements) {
    for(const anElement of elements) {
        const availabilityContainer = anElement.closest('[data-unavailable-disable]');
        //console.log(`availabilityContainer: ${availabilityContainer}`);
        if (availabilityContainer) {
            const el = availabilityContainer.querySelector('[data-unavailable-state]');
            if (el) {
                el.removeAttribute('hidden');
            }
            const thingsToCover = availabilityContainer.querySelectorAll('[data-unavailable-cover]');
            //console.log(`thingToCover: ${thingToCover}`);
            if (availabilityContainer) availabilityContainer.classList.add('unavail_disable');
            if (thingsToCover) thingsToCover.forEach((thing) => thing.classList.add('unavail_cover'));
        } else {
            console.error('data-unavailable-disable container not found, availability checks will not work');
        }
    }
}
function fgCheckAvailability() {
    console.log('checking availability...');
    enableAvailabilityElements();
    let unavailableByState = [];
    let unavailableByWh= [];

    // disable based on selected state (compliance)
    if (fgCurrentState()) {
        const states = document.querySelectorAll('[data-fg-states]');
        var i = 0;
        for (var anElement of states) {
            testDisable = window.fgAvailabilityTesting === true;
            if ((testDisable && i == 0) || (!anElement.dataset.fgStates || !anElement.dataset.fgStates.includes(fgCurrentState()))) {
                unavailableByState.push(anElement);
            }
            i++;
        }
        // show "Item unavailable in your state" elements
        console.log(`Disabling ${unavailableByState.length} wines not available in state ${fgCurrentState()}`);
        disableElements(unavailableByState);
        showUnavailable(unavailableByState);
    }

    // disable products based on WH (sold out)
    const whs = document.querySelectorAll('[data-fg-oos-wh]');
    for (var anElement of whs) {
        let list = anElement.dataset.fgOosWh;
        if (fgCurrentWarehouse() && list.indexOf(fgCurrentWarehouse()) >= 0 || list.indexOf('all') >= 0) {
            unavailableByWh.push(anElement);
        }
    }
    console.log(`Disabling ${unavailableByWh.length} wines Out of Stock in wh ${fgCurrentWarehouse()}`);
    disableElements(unavailableByWh, 'Out of Stock');

    //showUnavailable(unavailableByWh);
}

function fgCurrentWarehouse() {
    return fg_wh ? fg_wh.toLowerCase() : '';
}

function fgCurrentState() {
    return localStorage.getItem('fgw_state');
}

function showError(dialogElement, message) {
    const er = dialogElement.querySelector('.error');
    if (er) {
        er.innerHTML = message;
        er.classList.remove('hidden');
        er.removeAttribute('hidden');
    }
}

function initStateSelector(/** @type {Element} | null */ ssElement) {
    if (localStorage.getItem('fgw_state')) {
        ssElement.value = localStorage.getItem('fgw_state');
    }
    ssElement.addEventListener('change', (event) => {
        const stateSelected = event.target.value;
        window.localStorage.setItem('fgw_state', stateSelected);
        document.dispatchEvent(new CustomEvent('fgw_state_change', { 'new_state': stateSelected }));
    });
}

function injectShipTo(parentElement, insertBeforeSelector) {
    let injectBeforeElement = parentElement.querySelector(insertBeforeSelector);
    let shipTo = document.querySelector('.fg-modal-state .ship-to');

    let newShipTo = shipTo?.cloneNode(true);
    
    // replace the first option text with '' for space reasons
    newShipTo.querySelector('select').options[0].innerHTML = '';
    initStateSelector(newShipTo.querySelector('select'));
    if (injectBeforeElement) {
        parentElement?.insertBefore(newShipTo, injectBeforeElement);
    } else {
        parentElement.appendChild(newShipTo);
    }

    return newShipTo;
}

document.addEventListener('DOMContentLoaded', () => {

    // check if we have to display the dialog in the first place
    var popAgeDialog = false;
    const ageCheckKey = `fgAgeCheck-${Shopify.shop}`;
    const ageLastChecked = localStorage.getItem(ageCheckKey);
   //console.log(`ageLastChecked: ${ageLastChecked}`);

    if (ageLastChecked) {
        const ageCheckedDate = new Date(ageLastChecked);

        //console.log(`ageCheckedDate: ${ageCheckedDate}`);
        // if we didn't get a valid date, or the date we got is > FREQUENCY_MS, pop dialog
        if (!ageCheckedDate || (ageCheckedDate && (Date.now() - ageLastChecked > FREQUENCY_MS))) {
            popAgeDialog = true;
        }
    } else {
        popAgeDialog = true;
    }
    
        //console.log(`popAgeDialog: ${popAgeDialog}`);

    if (popAgeDialog) {
        const overlay = document.querySelector('.fg-modal-overlay');
        if (overlay) {
            document.body.classList.add('modal_open');
        }
    }

    // button handlers for dialog if needed
    const dialog = document.querySelector('.fg-modal-state');
    if (dialog) {
        dialog.querySelector('#fg-age-confirm').addEventListener('click', (event) => {
            event.preventDefault();
            const stateSelector = dialog.querySelector('.fgw_state_select');
            const stateSelected = stateSelector.value;
            if (!stateSelected) {
                showError(dialog, "You must select a state to enter.");
            } else {
                window.localStorage.setItem(ageCheckKey, JSON.stringify(new Date()));
                window.localStorage.setItem('fgw_state', stateSelected);
                document.dispatchEvent(new CustomEvent('fgw_state_change'));
                document.body.classList.remove('modal_open');
            }
        });
        dialog.querySelector('#fg-age-decline').addEventListener('click', (event) => {
            event.preventDefault();
            showError(dialog, 'You must be over 21 or older to enter.');
        });
    }

    // clone the state selector into the header. do not question this, it is a good idea.
    let desktopHeaderTopRight = document.querySelector('header-component [data-testid="header-top-right"]');
    let mobileNav = document.querySelector('header-drawer .menu-drawer__utility-links');

    injectShipTo(desktopHeaderTopRight, 'search-button');
    injectShipTo(mobileNav);
    
    // state selector event dispatch
    const stateSelects = document.querySelectorAll('select.fgw_state_select').forEach((ss) => initStateSelector(ss));

    // handle change state event
    document.addEventListener('fgw_state_change', (event) => {
        const stateSelected = window.localStorage.getItem('fgw_state');
        const stateSelects  = document.querySelectorAll('select.fgw_state_select');
        if (stateSelects && stateSelected) {
            stateSelects.forEach((ss) => ss.value = stateSelected);
        }
        setCurrentWarehouse();
        fgCheckAvailability();
    });

    // handle variant picker updates
    document.addEventListener('variant:update', (e) => { fgCheckAvailability();});

    // Horizon does fire an event when filters change, but the page is updated AFTER that.
    // So we have to wait a bit to run our check. There should be an event when they are
    // finished getting new data and moving things around.
    document.addEventListener('filter:update', (e) => { 
        setTimeout(() => {
            fgCheckAvailability();
        }, 1000);
    });
    setCurrentWarehouse();
    fgCheckAvailability();

    const headerTopRightObservable = document.querySelector('#header-group header-component .header__columns [data-testid="header-top-right"]');
    const headerNavObserver = new MutationObserver((mutations) => {
        mutations.forEach(mutation => {
            let ss = mutation.target.querySelector('select.fgw_state_select');
            if (!ss) {
                injectShipTo(mutation.target, 'search-button');
            }
        });
    });

    if (headerTopRightObservable) {
        headerNavObserver.observe(headerTopRightObservable, { childList: true });
    }

    const mobileNavObservable = document.querySelector('header-drawer .menu-drawer__utility-links');
    const mobileNavObserver = new MutationObserver((mutations) => {
        mutations.forEach(mutation => {
            let ss = mutation.target.querySelector('select.fgw_state_select');
            if (!ss) {
                injectShipTo(mutation.target);
            }
        });
    });

    if (mobileNavObservable) {
        mobileNavObserver.observe(mobileNavObservable, { childList: true });
    }

});

